import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=0004e75e&scoped=true"
import script from "./Note.vue?vue&type=script&lang=ts"
export * from "./Note.vue?vue&type=script&lang=ts"
import style0 from "./Note.scss?vue&type=style&index=0&id=0004e75e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004e75e",
  null
  
)

export default component.exports